/*
 * Libellés d'erreur par code HTTP.
 *
 * Le champ "message" de Spring est vide par défaut depuis Boot 2.3
 * (il faut server.error.include-message: always côté serveur).
 * On ne l'affiche donc que s'il est réellement renseigné, sinon on
 * retombe sur un libellé par code.
 */
export function messageErreur(error, libelles) {
    const reponse = error && error.response ? error.response : null;
    const message = reponse && reponse.data ? reponse.data.message : null;
    if (message) {
        return message;
    }
    const statut = reponse ? reponse.status : null;
    if (libelles && libelles[statut]) {
        return libelles[statut];
    }
    if (statut === 400) return "Données invalides.";
    if (statut === 401) return "Vous devez vous reconnecter.";
    if (statut === 403) return "Vous n'avez pas accès à cette ressource.";
    if (statut === 404) return "Ressource introuvable.";
    if (statut === 409) return "Opération impossible dans l'état actuel.";
    if (statut === 502 || statut === 503) return "Service momentanément indisponible, réessayez plus tard.";
    return "Echec de l'opération !";
}
